module.exports = __webpack_public_path__ + "static/media/Cyborg.4717fb2f.jpg";